import * as React from 'react';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../sanity';

export const NewsArticleTitleContent = () => {
  const {
    data,
  } = useSanityNewsByUrlId();
  if (data == null) {
    return null;
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{data.title}</>
  );
};
